/* eslint-disable max-lines */
import { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { getProductQuestions, saveComplianceInformation } from '../../../services/formService';
import { productNameURLMapping } from '../../../services/productNameURLMapping';
import { productMapping } from '../../../services/productMapping';
import ComplianceContent from './ComplianceContent';
import {
  DGI_MODAL_POLI,
  EMPLOYED,
  EMPLOYER_KNOCKOFF_REASON,
  KNOCK_OFF_MSSG_BODY_EMPLOYER,
  MANDATORY_FIELD_ERR,
  NOTCURREMP,
  NOTEMP_NOPREVEMP,
  NOTEMP_STUDENT,
  NOT_ELIGIBLE,
  NOT_ELIGIBLE_DESCRIPTION,
  NOT_EMPLOYED,
  PRODUCT_IRAFACIL,
  PRODUCT_PERSONAL,
  PRODUCT_PERSONALCD,
  PROGRESA_CONTIGO,
  RETIRED,
  SELF_EMPLOYED,
  VOUCHED_ERROR,
} from '../../../constants';
import { saveKnockOffData } from '../../DGI/CommonFunctions';
import CommonModal from '../../Modal/CommonModal';
import KnockOffModal from './KnockOffModal';
import { isBundle, isKnockOffValueEmployer } from '../../commonCode';
import BundleErrorModal from '../../Modal/BundleErrorModal';

/** CompliancePage will be rendered on UI when current page is 'compliance-info' for normal account opening process */
function CompliancePage(props) {
  const [isValidating, setIsValidating] = useState(false);
  const [isModalEmployerValidate, setIsModalEmployerValidate] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { history } = props;
  const {
    complianceItems,
    setComplianceItems,
    complianceItemsAnswer,
    setComplianceItemsAnswer,
    complianceData,
    setComplianceData,
    productType,
    productName,
    language,
    location,
    setCurrentPage,
    productQuestionsEN,
    productQuestionsES,
    isScreenFourDirty,
    setIsScreenFourDirty,
    setIsScreenFiveDirty,
    setIsFundingScreenDirty,
    setOpenProductQuestionModal,
    setEmploymentInformationErrors,
    accessToken,
    uploadGlobalDocId,
    uploadGlobalFiles,
    disable,
    setDisable,
    customerType,
    flowTypeETB,
    customerAppId,
  } = leadGenerationContext;

  const handleContinueDisable = (knockoutAnswer) => {
    let flagDisable;
    for (const property in knockoutAnswer) {
      if (property !== 'Act22' && knockoutAnswer[property]) {
        flagDisable = true;
        break;
      } else if (property === 'Act22' && knockoutAnswer[property]) {
        if (uploadGlobalDocId.act22 !== '' && uploadGlobalDocId.act22 !== null) {
          flagDisable = false;
        } else if (uploadGlobalDocId.act22 === '') {
          flagDisable = true;
          break;
        }
      }
    }
    setDisable(flagDisable);
  };
  const disableContinueButton = (newItemsAnswer, compliance) => {
    const knockoutAnswer = {};
    if (compliance && compliance?.questions && compliance.questions.length > 0) {
      compliance.questions.forEach((item) => {
        if (item.type === 'Knockout' && item.subQuestions.length === 0) {
          if (Object.prototype.hasOwnProperty.call(newItemsAnswer, item.name)) {
            knockoutAnswer[item.name] = newItemsAnswer[item.name];
          } else {
            knockoutAnswer[item.name] = false;
          }
        }
      });
    }
    handleContinueDisable(knockoutAnswer);
  };
  const handleOnLoadCompliancePage = async () => {
    setCurrentPage('compliance-info');
    const formData = {
      productType,
      productName,
      language,
      location,
      customerType,
      flowTypeETB,
      customerAppId,
    };
    if (
      accessToken &&
      Object.keys(productQuestionsEN).length > 0 &&
      Object.keys(productQuestionsES).length > 0
    ) {
      const prodData = await getProductQuestions(formData, 'ComplianceQuestions', accessToken);
      if (prodData && prodData.data) {
        const data = prodData.data.ComplianceQuestions[0];
        if (Object.keys(complianceData).length === 0) {
          data?.questions.forEach((question) => {
            complianceItemsAnswer[question.name] = '';
          });
          setComplianceItemsAnswer(complianceItemsAnswer);
        }
        setComplianceData(data);
        disableContinueButton(complianceItemsAnswer, data);
      }
    }
  };
  useEffect(() => {
    handleOnLoadCompliancePage();
  }, [accessToken, productQuestionsEN, productQuestionsES]);
  useEffect(() => {
    if (leadGenerationContext.productName === PROGRESA_CONTIGO) {
      leadGenerationContext.setEmploymentInformation({
        ...leadGenerationContext.employmentInformation,
        employmentStatus: EMPLOYED,
      });
    }
  }, []);
  /**
   * call save api for normal account opening products */
  const saveData = async () => {
    const data = {};
    data.applicationId = leadGenerationContext.applicationId;
    data.language = leadGenerationContext.language;
    data.location = leadGenerationContext.location;
    data.utmCampaign = leadGenerationContext.utmCampaign;
    data.utmMedium = leadGenerationContext.utmMedium;
    data.utmContent = leadGenerationContext.utmContent;
    data.utmTerm = leadGenerationContext.utmTerm;
    data.utmSource = leadGenerationContext.utmSource;
    data.branchCode = leadGenerationContext.branchCode;
    data.itemsAnswer = leadGenerationContext.complianceItemsAnswer;
    data.act22DocID = leadGenerationContext.uploadGlobalDocId.act22;
    data.complianceData = leadGenerationContext.complianceData;
    data.employmentInformation = leadGenerationContext.employmentInformation;
    let response = null;
    response = await saveComplianceInformation(data, leadGenerationContext.accessToken);
    return response;
  };

  useEffect(() => {
    disableContinueButton(complianceItemsAnswer, complianceData);
  }, [uploadGlobalDocId?.act22]);
  const itemNameCheck = (newItem) => {
    if (newItem.name === 'IsPoliticallyExposed') {
      setOpenProductQuestionModal(false);
    }
  };
  const setNewItems = (questionIndex, complianceItems1) => {
    let newItems1;
    if (questionIndex > 0) {
      if (!complianceItems1.includes(questionIndex)) {
        newItems1 = [...complianceItems1, questionIndex];
      } else {
        newItems1 = [...complianceItems1];
      }
    } else {
      newItems1 = [...complianceItems1];
    }
    return newItems1;
  };
  const itemPoliticallyExposed = async (newItem) => {
    if (newItem.name === 'IsPoliticallyExposed') {
      await saveKnockOffData(leadGenerationContext, DGI_MODAL_POLI);
      setOpenProductQuestionModal(true);
    }
  };
  const questionNames = (complianceItems1, newItem) =>
    complianceItems1.findIndex((item) => {
      if (
        complianceData?.questions &&
        complianceData.questions[item] &&
        complianceData.questions[item].subQuestions &&
        complianceData.questions[item].subQuestions.length > 0
      ) {
        return complianceData.questions[item].subQuestions.includes(newItem.name);
      }
      return complianceData.questions[item].name === newItem.name;
    });
  const newComplianceItems = (complianceItems1, index) => {
    let newItems1;
    if (index >= 0) {
      complianceItems1.splice(index + 1, complianceItems1.length - 1 - index);
      newItems1 = [...complianceItems1];
    } else {
      newItems1 = [...complianceItems1];
    }
    return newItems1;
  };
  const setNewElementsAnswer = (newElementsAnswer, newItem, result) => {
    let newItemsAnswer1;
    for (const property in newElementsAnswer) {
      if (property === newItem.name) {
        newItemsAnswer1 = { ...newItemsAnswer1, [property]: result };
      } else {
        newItemsAnswer1 = { ...newItemsAnswer1, [property]: newElementsAnswer[property] };
      }
    }
    return newItemsAnswer1;
  };
  const IsPoliticallyExposed2 = (newItem, newItemsAnswer, result) => {
    const newItemsAnswer1 = newItemsAnswer;
    if (newItem.name === 'IsPoliticallyExposed') {
      if (result) {
        for (const property in newItemsAnswer1) {
          if (property !== 'IsPoliticallyExposed') {
            newItemsAnswer1[property] = false;
          }
        }
        leadGenerationContext.setUploadGlobalFiles({ ...uploadGlobalFiles, act22: '' });
        leadGenerationContext.setUploadGlobalDocId((prevState) => ({ ...prevState, act22: null }));
        leadGenerationContext.setUploadGlobalStatus((prevState) => ({ ...prevState, act22: '' }));
        leadGenerationContext.setGlobalProgress((prevState) => ({ ...prevState, act22: 0 }));
        leadGenerationContext.setChecklistErrGlobal((pst) => ({ ...pst, act22: '' }));
        leadGenerationContext.setIsGlobalFileUploadingAll((disb) => ({ ...disb, act22: false }));
      }
    }
    return newItemsAnswer1;
  };
  const subQuestionAnswered2 = (subQuestions, newItemsAnswer1, subQuestionAnswered, question) => {
    const newItemsAnswer2 = newItemsAnswer1;
    if (subQuestions?.length > 0) {
      if (subQuestionAnswered) {
        newItemsAnswer2[question.name] = true;
      } else {
        newItemsAnswer2[question.name] = false;
      }
    }
    if (subQuestionAnswered) {
      newItemsAnswer2[question.name] = true;
    }
    return newItemsAnswer2;
  };
  const subQuestionAnswered1 = (complianceData1, newItemsAnswer) => {
    const newItemsAnswer1 = newItemsAnswer;
    if (complianceData1?.questions) {
      for (const item of complianceData1.questions) {
        const question = item;
        const { subQuestions } = question;
        let subQuestionAnswered = false;
        if (subQuestions?.length > 0) {
          for (const element of subQuestions) {
            if (newItemsAnswer1[element]) {
              subQuestionAnswered = true;
              break;
            }
          }
        }
        subQuestionAnswered2(subQuestions, newItemsAnswer1, subQuestionAnswered, question);
      }
    }
    return newItemsAnswer1;
  };
  const itemsHandler = async (newItem, result) => {
    setIsScreenFourDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    const newElementsAnswer = { ...complianceItemsAnswer, [newItem.name]: result };
    setComplianceItemsAnswer(newElementsAnswer);
    let newItemsAnswer = {};
    if (result === false) {
      itemNameCheck(newItem);
      const value = newItem.next.find((element) => element.value === 'false');
      const questionIndex =
        complianceData?.questions &&
        complianceData.questions.findIndex((item) => {
          if (value && value?.questions && value.questions.length > 0) {
            return item.name === value.questions[0];
          }
          return false;
        });
      let newItems = [];
      newItems = setNewItems(questionIndex, complianceItems);
      setComplianceItems(newItems);
    } else {
      await itemPoliticallyExposed(newItem);
      const index = questionNames(complianceItems, newItem);
      let newItems = [];
      newItems = newComplianceItems(complianceItems, index);
      setComplianceItems(newItems);
    }
    newItemsAnswer = setNewElementsAnswer(newElementsAnswer, newItem, result);

    newItemsAnswer = IsPoliticallyExposed2(newItem, newItemsAnswer, result);

    subQuestionAnswered1(complianceData, newItemsAnswer);
    setComplianceItemsAnswer(newItemsAnswer);
    disableContinueButton(newItemsAnswer, complianceData);
  };
  /**
   * Handle continue change */
  const continueStep = async (e) => {
    e.preventDefault();
    setIsValidating(true);
    const itemsAnswer = { ...leadGenerationContext.complianceItemsAnswer };
    const questions = complianceData?.questions ? complianceData.questions : {};
    let valid = true;
    for (const item of questions) {
      const question = item;
      if (question?.required) {
        if (question.name !== 'AreEngaged') {
          if (itemsAnswer[question.name] === true) {
            if (question.name === 'Act22') {
              if (uploadGlobalDocId.act22 === null) {
                valid = false;
                break;
              }
            } else {
              valid = false;
              break;
            }
          }
        }
      } else if (Object.prototype.hasOwnProperty.call(itemsAnswer, question.name)) {
        if (itemsAnswer[question.name] === '' || itemsAnswer[question.name] === false) {
          valid = false;
          break;
        }
      } else {
        valid = false;
        break;
      }
    }

    let employmentInformationErrors = { ...leadGenerationContext.employmentInformationErrors };
    if (valid) {
      const employmentInformation = { ...leadGenerationContext.employmentInformation };
      if (employmentInformation?.employmentStatus) {
        if (employmentInformation.employmentStatus === EMPLOYED) {
          if (!employmentInformation.employer) {
            employmentInformationErrors = {
              ...employmentInformationErrors,
              employer: MANDATORY_FIELD_ERR,
            };
            setEmploymentInformationErrors(employmentInformationErrors);
          }
          if (employmentInformation?.employer) {
            const validateEmployerVal = await isKnockOffValueEmployer(
              employmentInformation?.employer
            );
            if (validateEmployerVal) {
              valid = false;
              setIsModalEmployerValidate(true);
              setOpenModal(true);
              await saveKnockOffData(leadGenerationContext, EMPLOYER_KNOCKOFF_REASON);
            }
            // setEmploymentInformationErrors(employmentInformationErrors);
          }
          if (!employmentInformation?.occupation) {
            employmentInformationErrors = {
              ...employmentInformationErrors,
              occupation: MANDATORY_FIELD_ERR,
            };
            setEmploymentInformationErrors(employmentInformationErrors);
          }
          if (!employmentInformation?.annualIncome) {
            employmentInformationErrors = {
              ...employmentInformationErrors,
              annualIncome: MANDATORY_FIELD_ERR,
            };
            setEmploymentInformationErrors(employmentInformationErrors);
          }
        }
        if (employmentInformation?.employmentStatus === SELF_EMPLOYED) {
          if (!employmentInformation?.employer) {
            employmentInformationErrors = {
              ...employmentInformationErrors,
              employer: MANDATORY_FIELD_ERR,
            };
            setEmploymentInformationErrors(employmentInformationErrors);
          }
          if (!employmentInformation?.occupation) {
            employmentInformationErrors = {
              ...employmentInformationErrors,
              occupation: MANDATORY_FIELD_ERR,
            };
            setEmploymentInformationErrors(employmentInformationErrors);
          }
          if (!employmentInformation?.annualIncome) {
            employmentInformationErrors = {
              ...employmentInformationErrors,
              annualIncome: MANDATORY_FIELD_ERR,
            };
            setEmploymentInformationErrors(employmentInformationErrors);
          }
        }
        if (employmentInformation?.employmentStatus === NOT_EMPLOYED) {
          if (employmentInformation?.reason) {
            if (employmentInformation?.reason === NOTEMP_STUDENT) {
              if (!employmentInformation?.schoolName) {
                employmentInformationErrors = {
                  ...employmentInformationErrors,
                  schoolName: MANDATORY_FIELD_ERR,
                };
                setEmploymentInformationErrors(employmentInformationErrors);
              }
              if (!employmentInformation?.sourceOfCurrentIncome) {
                employmentInformationErrors = {
                  ...employmentInformationErrors,
                  sourceOfCurrentIncome: MANDATORY_FIELD_ERR,
                };
                setEmploymentInformationErrors(employmentInformationErrors);
              }
            }
            if (employmentInformation?.reason === NOTEMP_NOPREVEMP) {
              if (!employmentInformation?.sourceOfCurrentIncome) {
                employmentInformationErrors = {
                  ...employmentInformationErrors,
                  sourceOfCurrentIncome: MANDATORY_FIELD_ERR,
                };
                setEmploymentInformationErrors(employmentInformationErrors);
              }
              if (!employmentInformation?.annualIncome) {
                employmentInformationErrors = {
                  ...employmentInformationErrors,
                  annualIncome: MANDATORY_FIELD_ERR,
                };
                setEmploymentInformationErrors(employmentInformationErrors);
              }
            }
            if (employmentInformation?.reason === NOTCURREMP) {
              if (!employmentInformation?.previousEmployer) {
                employmentInformationErrors = {
                  ...employmentInformationErrors,
                  previousEmployer: MANDATORY_FIELD_ERR,
                };
                setEmploymentInformationErrors(employmentInformationErrors);
              }
              if (employmentInformation?.previousEmployer) {
                const validateEmployerVal = await isKnockOffValueEmployer(
                  employmentInformation.previousEmployer
                );
                if (validateEmployerVal) {
                  valid = false;
                  setIsModalEmployerValidate(true);
                  setOpenModal(true);
                  await saveKnockOffData(leadGenerationContext, EMPLOYER_KNOCKOFF_REASON);
                }
              }
              if (!employmentInformation?.occupation) {
                employmentInformationErrors = {
                  ...employmentInformationErrors,
                  occupation: MANDATORY_FIELD_ERR,
                };
                setEmploymentInformationErrors(employmentInformationErrors);
              }
              if (!employmentInformation?.annualIncome) {
                employmentInformationErrors = {
                  ...employmentInformationErrors,
                  annualIncome: MANDATORY_FIELD_ERR,
                };
                setEmploymentInformationErrors(employmentInformationErrors);
              }
              if (!employmentInformation?.sourceOfCurrentIncome) {
                employmentInformationErrors = {
                  ...employmentInformationErrors,
                  sourceOfCurrentIncome: MANDATORY_FIELD_ERR,
                };
                setEmploymentInformationErrors(employmentInformationErrors);
              }
            }
          } else {
            employmentInformationErrors = {
              ...employmentInformationErrors,
              reason: MANDATORY_FIELD_ERR,
            };
            setEmploymentInformationErrors(employmentInformationErrors);
          }
        }
        if (employmentInformation?.employmentStatus === RETIRED) {
          if (!employmentInformation?.previousEmployer) {
            employmentInformationErrors = {
              ...employmentInformationErrors,
              previousEmployer: MANDATORY_FIELD_ERR,
            };
            setEmploymentInformationErrors(employmentInformationErrors);
          }
          if (employmentInformation?.previousEmployer) {
            const validateEmployerVal = await isKnockOffValueEmployer(
              employmentInformation.previousEmployer
            );
            if (validateEmployerVal) {
              valid = false;
              setIsModalEmployerValidate(true);
              setOpenModal(true);
              await saveKnockOffData(leadGenerationContext, EMPLOYER_KNOCKOFF_REASON);
            }
          }
          if (!employmentInformation?.occupation) {
            employmentInformationErrors = {
              ...employmentInformationErrors,
              occupation: MANDATORY_FIELD_ERR,
            };
            setEmploymentInformationErrors(employmentInformationErrors);
          }
          if (!employmentInformation?.annualIncome) {
            employmentInformationErrors = {
              ...employmentInformationErrors,
              annualIncome: MANDATORY_FIELD_ERR,
            };
            setEmploymentInformationErrors(employmentInformationErrors);
          }
          if (!employmentInformation?.sourceOfCurrentIncome) {
            employmentInformationErrors = {
              ...employmentInformationErrors,
              sourceOfCurrentIncome: MANDATORY_FIELD_ERR,
            };
            setEmploymentInformationErrors(employmentInformationErrors);
          }
        }
      } else {
        employmentInformationErrors = {
          ...employmentInformationErrors,
          employmentStatus: MANDATORY_FIELD_ERR,
        };
        setEmploymentInformationErrors(employmentInformationErrors);
      }
      for (const property in employmentInformationErrors) {
        if (
          employmentInformationErrors[property] &&
          employmentInformationErrors[property].length > 0
        ) {
          valid = false;
          break;
        }
      }
    }
    if (valid) {
      const prodName = productMapping(productName);
      if (isScreenFourDirty) {
        const result = await saveData();
        if (result && result.status === 201) {
          setIsScreenFourDirty(false);
          setIsValidating(false);
          /**
           * Navigate to funding screen if products are IRA Facil, Personal IRA, otherwise
           * navigate to product Info screen */
          if (prodName === PRODUCT_IRAFACIL || prodName === PRODUCT_PERSONALCD) {
            history.push(
              `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
                productName
              )}/funding-info`
            );
          } else {
            history.push(
              `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
                productName
              )}/product-info`
            );
          }
        }
      } else {
        setIsValidating(false);
        if (prodName === PRODUCT_IRAFACIL || prodName === PRODUCT_PERSONALCD) {
          history.push(
            `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
              productName
            )}/funding-info`
          );
        } else {
          history.push(
            `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
              productName
            )}/product-info`
          );
        }
      }
    } else if (employmentInformationErrors && Object.keys(employmentInformationErrors).length > 0) {
      for (const field in employmentInformationErrors) {
        if (employmentInformationErrors[field]) {
          const element = document.getElementById(field);
          if (element) {
            element.focus();
            break;
          }
        }
      }
    }
    setIsValidating(false);
  };

  return (
    <>
      <ComplianceContent
        disable={disable}
        itemsHandler={itemsHandler}
        isValidating={isValidating}
        continueStep={continueStep}
      />
      {leadGenerationContext.openModalGlobal && (
        <CommonModal
          message={leadGenerationContext.modalMessageGlobal}
          setIsModal={leadGenerationContext.setOpenModalGlobal}
          openModal={leadGenerationContext.openModalGlobal}
        />
      )}
      {isModalEmployerValidate && !isBundle(productName) && (
        <KnockOffModal
          message={{ message: KNOCK_OFF_MSSG_BODY_EMPLOYER, isKnockOff: true }}
          setIsModal={setOpenModal}
          openModal={openModal}
        />
      )}
      {isModalEmployerValidate && isBundle(productName) && (
        <BundleErrorModal
          message={{
            errorHead: VOUCHED_ERROR,
            errorTitle: NOT_ELIGIBLE,
            errorDescription: NOT_ELIGIBLE_DESCRIPTION,
          }}
          setIsModal={setOpenModal}
          openModal={openModal}
        />
      )}
    </>
  );
}

export default withRouter(CompliancePage);

CompliancePage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
